(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/components/product-card.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/components/product-card.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


const Button = svs.ui.ReactButton;
const appendProductAction = svs.tickets_giftshop.gift.giftform.cart.actions.appendProductAction;
const animations = svs.tickets_giftshop.products.animations;
const Image = svs.content.image_v2.Image;
const ProductCard = _ref => {
  let _ref$isHidingInteract = _ref.isHidingInteraction,
    isHidingInteraction = _ref$isHidingInteract === void 0 ? false : _ref$isHidingInteract,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    productCount = _ref.productCount,
    onSelect = _ref.onSelect,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product,
    branding = _ref.branding;
  const productVariation = product.productVariation,
    productId = product.productId,
    productPrice = product.productPrice,
    productName = product.productName,
    productDescription = product.productDescription,
    type = product.type,
    skinId = product.skinId,
    productImage = product.productImage;
  const hasRequiredFields = productName && !isNaN(productPrice) && productId;
  const imageRef = React.useRef(null);
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hasRendered = _React$useState2[0],
    setHasRendered = _React$useState2[1];

  React.useEffect(() => {
    if (hasRendered && productCount > 0) {
      animations.productCardImageAnimation(imageRef.current, {
        delay: 1
      });
    }
  }, [hasRendered]);
  React.useEffect(() => {
    if (hasRequiredFields && hasRendered) {
      animations.productCardImageAnimation(imageRef.current, {});
    } else {
      setHasRendered(true);
    }
  }, [productCount]);
  const handleSelectClick = e => {
    e.preventDefault();
    onSelect && onSelect(productId, productVariation, type, skinId);
  };
  if (!hasRequiredFields) return null;
  return React.createElement("div", {
    className: "col-xs-6 col-sm-4 col-md-3"
  }, React.createElement("div", {
    className: "f-body tg-product-card tg-product-card-".concat(branding || 'default')
  }, React.createElement("div", {
    className: "tg-product-card-image-container",
    ref: imageRef
  }, React.createElement(Image, {
    cssSelectors: "tg-product-card-image",
    image: _objectSpread(_objectSpread({}, productImage), {}, {
      altText: "".concat(productName, " bild"),
      sizes: '(min-width: 320px) 320px, 100vw'
    })
  })), React.createElement("h4", {
    className: "h4 f-bold margin-bottom-0"
  }, "".concat(productName, " ").concat(svs.utils.format.Currency(productPrice), " kr")), React.createElement("p", {
    className: "p tg-product-card-description f-200"
  }, productDescription), !isHidingInteraction && React.createElement(Button, {
    block: true,
    disabled: isDisabled,
    inverted: true,
    onClick: handleSelectClick,
    size: 100,
    title: "Ge bort ".concat(productName, " ").concat(svs.utils.format.Currency(productPrice), " kr")
  }, "L\xE4gg till")));
};
const mapDispatch = dispatch => ({
  onSelect: (productId, productVariation, productType, skinId) => dispatch(appendProductAction(productId, productVariation, productType, null, skinId))
});
const mapState = state => ({
  branding: state.settings.branding
});
svs.tickets_giftshop.products.components.ProductCard = ReactRedux.connect(mapState, mapDispatch)(ProductCard);

 })(window);